import axios from "@/libs/api.request";

// 获取超时未派列表
export const getTimeoutUnsent = data => {
  return axios.request({
    url: "/endpoint/analyze/timeOutNotDispatched",
    method: "post",
    data
  });
};
